export default "__VITE_ASSET__DKPPNOqX__"